import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Input, Icon } from 'loyal-react'
import Delay from 'features/LikePlus/Interval/Delay'
import { calculatorPointsToCash } from 'features/LikePlus/ducks'

class Body extends Component {
  constructor (props) {
    super(props)
    this.state = {
      credit: this.props.initialCredit,
      // TODO: trazer total de pontos do participante
      points: this.props.balance.pointsValue,
      checked: false,
      pointsIsValid: true
    }
  }

  componentDidUpdate (prev) {
    let calculatorPoints = this.props.calculatorPoints
    if (calculatorPoints && (prev.calculatorPoints !== calculatorPoints)) {
      this.handleCalculatorPoints()
    }
  }

  convertMoney = (value, minimumDigits = 2, maximumDigits = 2) => {
    return value.toLocaleString('pt-br', {
      minimumFractionDigits: minimumDigits,
      maximumFractionDigits: maximumDigits
    })
  }

  async handleCredit (el) {
    let val = el.target.value
    let minimumBalance = process.env.REACT_APP_LIKEPLUS_MININUM_BALANCE || '100'
    if (val) {
      if (val < parseInt(minimumBalance)) {
        this.setState({ pointsIsValid: false })
        this.props.handleDisabledConfirmButton(true)
      } else {
        this.setState({ pointsIsValid: true })
        this.ClearPointsCheck()
        let delayedCallBack = await Delay(this.props.intervalObservable, 1500, val, async (val) => {
          this.props.handleInitialCredit(val)
          this.props.calculatorPointsToCash(val)
        })
        this.props.handleIntervalObservable(delayedCallBack)
      }
    } else {
      this.props.handleInitialCredit(0)
      this.props.handleInitialMiles(0)
      this.props.handleDisabledConfirmButton(true)
    }
  }

  async handlePoint (el) {
    if (el.target.checked) {
      this.props.handleInitialCredit(this.state.points)
      this.props.calculatorPointsToCash(this.state.points)
      this.ClearCreditInput()
    } else {
      this.setState({ credit: 0 })
      this.props.handleInitialCredit(0)
      this.props.handleDisabledConfirmButton(true)
    }
    this.setState({ checked: !this.state.checked })
  }

  async handleCalculatorPoints () {
    let calculatorPoints = this.props.calculatorPoints
    if (calculatorPoints && calculatorPoints.success) {
      let money = calculatorPoints.pointsCash.money
      this.setState({ credit: money })
      this.props.handleInitialMiles(money)
      if (money > 0) {
        this.props.handleDisabledConfirmButton(false)
      }
    } else {
      this.setState({ credit: 0 })
      this.props.handleInitialCredit(0)
      this.props.handleInitialMiles(0)
      this.props.handleDisabledConfirmButton(true)
    }
  }

  async ClearCreditInput () {
    const creditInput = document.querySelector('#credit')
    if (creditInput) {
      creditInput.value = ''
    }
  }

  async ClearPointsCheck () {
    if (this.state.checked) {
      this.setState({ checked: false })
    }
  }

  render () {
    let minimumBalance = process.env.REACT_APP_LIKEPLUS_MININUM_BALANCE || '100'
    return (
      <div className='col-12  bg-ui-4 border-color-ui-3 border-bottom p-2'>
        <div className='col-12'>
          <p className='my-2 p-0'>
            Realize a primeira recarga para aproveitar o seu cartão em lojas
            físicas e na internet.
          </p>
        </div>
        <div className='d-flex flex-column flex-md-row justify-content-between align-items-md-start align-items-center'>
          <div className='col-12 col-md-6 p-0 d-flex flex-column'>
            <Input
              id='credit'
              label='Quantos pontos deseja creditar'
              type='number'
              childrenClassName='has-content'
              valid={this.state.pointsIsValid ? null : false}
              data-error={`Mínimo de ${this.convertMoney(minimumBalance, 0, 0)} pontos`}
              onChange={e => this.handleCredit(e)}
            />
          </div>
          <div className='my-2'>
            <Icon iconName='icon_equal' className='color-brand-2-like' />
          </div>
          <div className='col-md-5 col-12'>
            <p className='mb-2'>
              <strong>Valor a ser creditado no Cartão Like Mais</strong>
            </p>
            <h3 className='color-brand-2-like'>{`R$ ${this.convertMoney(this.state.credit, 2, 2)}`}</h3>
          </div>
        </div>
      </div>
    )
  }
}

Body.propTypes = {
  initialCredit: PropTypes.any,
  handleInitialCredit: PropTypes.func,
  handleInitialMiles: PropTypes.func,
  balance: PropTypes.object,
  intervalObservable: PropTypes.any,
  handleIntervalObservable: PropTypes.func,
  handleDisabledConfirmButton: PropTypes.func,
  calculatorPointsToCash: PropTypes.func,
  calculatorPoints: PropTypes.object
}

const mapStateToProps = ({ likeplus }) => ({
  calculatorPoints: likeplus.calculatorPoints
})

const mapDispatchToProps = dispatch => ({
  calculatorPointsToCash: (points) => dispatch(calculatorPointsToCash(points))
})

export default connect(mapStateToProps, mapDispatchToProps)(Body)



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/RequestCard/Credit/Body.js